import developmentConfig from "../../config/app.development.config.json";

import {
  EMPTY_STRING,
  ENV_DEV,
  ENV_TEST,
  ENV_VPN,
  UNDEFINED,
} from "../Constants/CommonConstants";

const config = window.APP_CONFIG;

const environment = "sbx01";
const ocpHost = "fpact-dev01.fpact.ocplower.ocpnp.calheers.net";
const ocpComponents = {
  fpactAccount: { ocpName: "fpact-account", port: 80 },
};

const EndpointService = (key) => {
  const data =
    process.env.NODE_ENV === ENV_DEV || process.env.NODE_ENV === ENV_TEST
      ? developmentConfig[key]
      : config[key];
  const port = window.location.port || EMPTY_STRING;
  const locationOrigin = window.location.origin;
  const endpoint =
    typeof locationOrigin === UNDEFINED
      ? `${window.location.protocol}//${window.location.hostname}${port}`
      : locationOrigin;

  if (process.env.REACT_APP_ENV === ENV_VPN) {
    const firstHalf = data?.slice(0, data.indexOf("/v1"));
    const serviceName = firstHalf?.slice(
      firstHalf.lastIndexOf("/") + 1,
      firstHalf.length
    );
    const hostPortName = serviceName?.replace("-", "_");
    const hostName = ocpHost
      .replace("{ocpName}", ocpComponents[hostPortName]?.ocpName)
      .replace("{ENV}", environment);
    return data?.replace("{APP_URL}", `http://${hostName}`);
  }
  return data?.replace("{APP_URL}", endpoint);
};

export default EndpointService;
